import { Interpolation } from "@emotion/core";
import { Colors } from "../../../../design-tokens/colors";
import { DarkTheme, Device } from "../../../../design-tokens/media-queries";
import { Fonts } from "../../../../design-tokens/fonts";
import { grid } from "../../../../design-tokens/grid";
import { Border } from "../../../../design-tokens/borders";

const table: Interpolation = {
  overflowX: "auto",
  marginBottom: grid(4),

  "::-webkit-scrollbar": {
    height: 10,
  },

  "::-webkit-scrollbar-track": {
    backgroundColor: Colors.LightGrey,

    [DarkTheme]: {
      backgroundColor: Colors.DarkModeDeepBlack,
    },
  },

  "::-webkit-scrollbar-thumb": {
    backgroundColor: Colors.BorderGrey,
    borderRadius: "10px",

    [DarkTheme]: {
      backgroundColor: Colors.DarkModeBorder,
    },
  },

  [Device.Mobile]: {
    marginLeft: grid(-2),
    marginRight: grid(-2),
  },

  [Device.DesktopTablet]: {
    borderRadius: Border.Radius,
  },
};

const row: Interpolation = {
  position: "relative",
  display: "flex",

  "> *": {
    flex: 1,
    minWidth: grid(5),

    "&:first-of-type": {
      position: "sticky",
      left: 0,
      flexBasis: grid(12),
      flexShrink: 0,
      flexGrow: 0,

      [Device.Mobile]: {
        flexBasis: grid(8),
      },
    },
  },
};

const header: Interpolation = {
  fontSize: 18,
  fontWeight: Fonts.Weight.Bold,

  "> *": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: grid(4),
    backgroundColor: Colors.LightGrey,

    [DarkTheme]: {
      backgroundColor: Colors.DarkModeDeepBlack,
    },
  },
};

const bodyHeader: Interpolation = {
  backgroundColor: Colors.LightGrey,

  "> *": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: grid(4),

    [Device.Mobile]: {
      height: grid(3.5),
    },
  },

  [DarkTheme]: {
    backgroundColor: Colors.DarkModeDeepBlack,
  },
};

const bodyColumn: Interpolation = {
  fontWeight: Fonts.Weight.Bold,

  "> *": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: grid(4),

    [Device.Mobile]: {
      height: grid(3.5),
    },
  },
};

const styles = {
  table,
  row,
  header,
  bodyHeader,
  bodyColumn,
};

export default styles;
